module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp2_3009.1ffb6c1a.png";